import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getWorkingStatus = createAsyncThunk(
  "admin/working-status",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/working-status", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getWorkingStatusById = createAsyncThunk(
  "admin/working-status/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/working-status/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortWorkingStatus = createAsyncThunk(
  "admin/working-status/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/working-status/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postWorkingStatus = createAsyncThunk(
  "admin/working-status/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/working-status", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteWorkingStatus = createAsyncThunk(
  "admin/working-status/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/working-status/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateWorkingStatus = createAsyncThunk(
  "admin/working-status/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/working-status/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const workingStatusSlice = createSlice({
  name: "Working Status Store",
  initialState: initialState,
  reducers: {
    addWorkingStatus(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortWorkingStatus(state, action) {
      state.data.docs = action.payload;
    },
    deleteWorkingStatus(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editWorkingStatus(state, action) {
      state.data.docs = state.data.docs.map((item) =>
        item._id === action.payload._id ? action.payload : item
      ); 
      state.data.docs.shift();
    },
  },
  extraReducers: {
    [getWorkingStatus.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getWorkingStatus.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getWorkingStatus.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getWorkingStatusById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getWorkingStatusById.fulfilled]: (state, action) => {
      state.data.docs.unshift(action.payload.data);
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getWorkingStatusById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortWorkingStatus.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortWorkingStatus.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortWorkingStatus.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postWorkingStatus.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postWorkingStatus.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postWorkingStatus.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteWorkingStatus.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteWorkingStatus.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteWorkingStatus.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateWorkingStatus.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateWorkingStatus.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateWorkingStatus.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const workingStatusActions = workingStatusSlice.actions;

export default workingStatusSlice.reducer;
